import { FormField, Input } from "@repo/skapa";
import { t } from "@repo/translation";
import { useState } from "react";

import { useSetDebounceValue } from "../hooks/useSetDebounceValue";

interface InputFieldProps {
  id: string;
  autoFocus?: boolean;
  label: string;
  editable?: boolean;
  value?: string;
  optional?: boolean;
  error?: boolean;
  onChange?: (newValue?: string) => void;
}
export const InputField = ({
  id,
  autoFocus,
  label,
  value,
  editable,
  error,
  optional,
  onChange,
}: InputFieldProps) => {
  const saveValue = (newValue?: string) => {
    if (value !== newValue) {
      onChange?.(newValue);
    }
  };
  const [textValue, setTextValue] = useState(value);
  const { setValueDebounced, clearDebounce } = useSetDebounceValue(
    saveValue,
    2500
  );

  return (
    <FormField
      shouldValidate={true}
      valid={!error}
      fieldHelper={
        optional
          ? {
              msg: t("label.optional"),
            }
          : undefined
      }
      validation={{
        msg: t("prompt.mandatory_field"),
        id: "error",
        type: "error",
      }}
    >
      <Input
        id={id}
        type="text"
        autoFocus={autoFocus}
        label={label}
        disabled={editable === false}
        value={textValue ?? ""}
        onChange={(e) => {
          setTextValue(e.target.value);
          setValueDebounced(e.target.value);
        }}
        onBlur={() => {
          clearDebounce();
          saveValue(textValue);
        }}
      />
    </FormField>
  );
};
